import { getAccountsApi, getDocumentsApi, postAccountsApi } from "@Shared/utils/ajax";
export const getQuickAppSchema = async (flow, locale) => {
  const endpoint = "/widget/application";
  return getAccountsApi({
    flow,
    locale
  }, endpoint);
};
export const getLeadSchema = async locale => {
  const endpoint = "/widget/lead";
  return getAccountsApi({
    locale
  }, endpoint);
};
export const getLeadLoanSchema = async locale => {
  const endpoint = "/widget/lead-loan";
  return getAccountsApi({
    locale
  }, endpoint);
};
export const getWidgetDisclaimers = async subdomain => {
  return getAccountsApi({}, `/subdomain${subdomain}/disclaimers`);
};
export const downloadDisclaimer = async (documentId, fileName) => {
  const endpoint = `/${documentId}`;
  return getDocumentsApi({
    fileName
  }, endpoint);
};
export const submitWidget = async (payload, endpoint) => {
  return postAccountsApi(payload, endpoint);
};
export const submitQuickAppSchema = async (payload, params) => {
  const parsedParams = $.param(params);
  const paramsString = parsedParams ? `?${parsedParams}` : "";
  return postAccountsApi(payload, `/widget/application${paramsString}`);
};
export const submitLeadSchema = async (payload, params) => {
  const parsedParams = $.param(params);
  const paramsString = parsedParams ? `?${parsedParams}` : "";
  return postAccountsApi(payload, `/widget/lead${paramsString}`);
};
export const submitLeadLoanSchema = async (payload, params) => {
  const parsedParams = $.param(params);
  const paramsString = parsedParams ? `?${parsedParams}` : "";
  return postAccountsApi(payload, `/widget/lead-loan${paramsString}`);
};